import { Check, Minus } from 'lucide-react';
import { Table, TableHeader, TableBody, TableHead, TableRow, TableCell } from '@/components/ui/table';

const ROWS = [
  ['Best for', 'Agents & brokerages', 'One home, one sale', 'New-construction builders'],
  ['Billing', 'Annual membership', 'One-time fee', 'Per-community, one-time'],
  ['Sort-to-top placement', true, true, true],
  ['Retargeting ads', true, false, true],
  ['3D / Matterport tour', true, true, true],
  ['Buyer lead vetting', true, false, true],
  ['Performance dashboard', true, true, true],
];

const Cell = ({ v }) =>
  typeof v === 'boolean' ? (
    v ? <Check size={16} className="mx-auto text-blue-600" /> : <Minus size={16} className="mx-auto text-slate-300" />
  ) : (
    <span className="text-sm text-slate-700">{v}</span>
  );

export function AdvertiseComparisonTable() {
  return (
    <div className="reveal overflow-hidden rounded-2xl border border-slate-200 bg-white">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="text-slate-500">Compare options</TableHead>
            <TableHead className="text-center font-semibold text-slate-900">Agent Membership</TableHead>
            <TableHead className="text-center font-semibold text-slate-900">Listing Boost</TableHead>
            <TableHead className="text-center font-semibold text-slate-900">Community Boost</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {ROWS.map(([label, a, b, c]) => (
            <TableRow key={label}>
              <TableCell className="font-medium text-slate-900">{label}</TableCell>
              <TableCell className="text-center"><Cell v={a} /></TableCell>
              <TableCell className="text-center"><Cell v={b} /></TableCell>
              <TableCell className="text-center"><Cell v={c} /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
